import React from 'react';

import {
  BackToCatalog,
  Block,
  CompanyInfo,
  ProductAdvantages,
  ProductDetail,
  ProductDetails,
  ProductTitle,
} from './MainInfoLoader.styles';

function MainInfoLoader() {
  return (
    <Block>
      <BackToCatalog />

      <ProductTitle />

      <CompanyInfo />

      <ProductAdvantages />

      <ProductDetails>
        <ProductDetail />

        <ProductDetail />

        <ProductDetail />
      </ProductDetails>

      <ProductDetails>
        <ProductDetail />

        <ProductDetail />
      </ProductDetails>
    </Block>
  );
}

export default MainInfoLoader;
